import React, { Component } from "react";
import uploadIcon from '../../../assets/images/Icon feather-upload-cloud.png'
import './style.scss';
import { format } from 'date-fns';
import { connect } from "react-redux";
import { taxCollectionAction } from "../../../store/actions/file-conversion/tax-collection";
import { Buffer } from 'buffer'
import FileUpload from "../../../components/file-upload";

class TaxCollectionView extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    src: null,
    file: null,
    fileConvertError: false,
  };

  onSelectFile = (e, drop) => {
    let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
    if (!file) return;
    let reader = new FileReader();
    this.setState({
      file: file,
      fileConvertError: null,
      txtCollectionFileName: file.name,
    });
    reader.readAsDataURL(file);
    reader.onload = (res) =>
      this.setState({
        src: res.target.result,
      });
  };

  uploadFile = async (fileInput) => {
    const i = this.state.src.indexOf("base64,");
    const buffer = Buffer.from(this.state.src.slice(i + 7), "base64");
    const file = new File([buffer], "name", {
      type: "application/vnd.ms-excel",
    });

    const fd = new FormData();
    fd.append("file", file);
    fd.append("filename", file.name);
    await this.props.taxCollectionAction(fd);
    let taxCollection = this.props.TaxCollectionReducer;

    if (taxCollection === undefined && taxCollection.msg === "Error converting file")
      return this.setState({ fileConvertError: taxCollection.msg });
    const url = window.URL.createObjectURL(
      new Blob([taxCollection], { type: "application/*" })
    );

    fileInput.current.value = null;
    this.setState({
      src: null,
      txtCollectionFileName: "",
    });
    let date = new Date();
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Tax-collection-${format(date, "MM-dd-yy-mmss")}.iif`
    );
    document.body.appendChild(link);
    link.click();

  };

  render() {
    return (
      <FileUpload
        HtmlFor="upld_tax_collection_file"
        FileError={this.state.fileConvertError}
        CAPTION="TAX COLLECTION"
        OnSelectFile={this.onSelectFile}
        UploadFile={this.uploadFile}
        Color="#47E5EB"
        Accept=".csv,.txt"
      />
    );
  }
}
const mapStateToProps = ({ UserReducer, TaxCollectionReducer }) => ({ UserReducer, TaxCollectionReducer });

export default connect(mapStateToProps, { taxCollectionAction })(TaxCollectionView);;
